// Production optimizations and utilities

// Remove console logs in production
export const removeConsoleLogs = () => {
  if (process.env.NODE_ENV === 'production') {
    console.log = () => {};
    console.warn = () => {};
    console.error = () => {};
    console.info = () => {};
    console.debug = () => {};
  }
};

// Performance monitoring
export const performanceMonitor = {
  mark: (name) => {
    if (typeof performance !== 'undefined' && performance.mark) {
      performance.mark(name);
    }
  },
  
  measure: (name, startMark, endMark) => {
    if (typeof performance !== 'undefined' && performance.measure) {
      try {
        performance.measure(name, startMark, endMark);
        const measures = performance.getEntriesByName(name);
        if (measures.length > 0) {
          console.log(`${name}: ${measures[measures.length - 1].duration}ms`);
        }
      } catch (error) {
        // Ignore measurement errors
      }
    }
  }
};

// Image optimization utilities
export const imageOptimizations = {
  // Lazy load images
  lazyLoadImage: (img) => {
    if ('IntersectionObserver' in window) {
      const imageObserver = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            const img = entry.target;
            img.src = img.dataset.src;
            img.classList.remove('lazy');
            imageObserver.unobserve(img);
          }
        });
      });
      
      imageObserver.observe(img);
    } else {
      // Fallback for browsers without IntersectionObserver
      img.src = img.dataset.src;
    }
  }
};

// Memory management
export const memoryManagement = {
  // Clear unused objects from memory
  clearUnusedObjects: () => {
    if (global.gc) {
      global.gc();
    }
  },
  
  // Monitor memory usage
  getMemoryUsage: () => {
    if (performance.memory) {
      return {
        used: Math.round(performance.memory.usedJSHeapSize / 1048576),
        total: Math.round(performance.memory.totalJSHeapSize / 1048576),
        limit: Math.round(performance.memory.jsHeapSizeLimit / 1048576)
      };
    }
    return null;
  }
};

// Initialize production optimizations
export const initializeProductionOptimizations = () => {
  removeConsoleLogs();
  
  // Add performance monitoring
  performanceMonitor.mark('app-start');
  
  // Monitor memory usage in development
  if (process.env.NODE_ENV === 'development') {
    setInterval(() => {
      const memory = memoryManagement.getMemoryUsage();
      if (memory) {
        console.log(`Memory usage: ${memory.used}MB / ${memory.total}MB (limit: ${memory.limit}MB)`);
      }
    }, 30000); // Check every 30 seconds
  }
};
